import { useSearchParams, Link } from "react-router-dom";
import { COACHES, GAMES, GUIDES, EVENTS } from "@/lib/mockData";
import { Search as SearchIcon } from "lucide-react";
import { useState } from "react";

export default function Search() {
  const [params, setParams] = useSearchParams();
  const q = params.get("q") || "";
  const [term, setTerm] = useState(q);
  const query = q.toLowerCase();

  const coaches = COACHES.filter(c => c.name.toLowerCase().includes(query) || c.game.toLowerCase().includes(query) || c.specialty.toLowerCase().includes(query));
  const games = GAMES.filter(g => g.title.toLowerCase().includes(query));
  const guides = GUIDES.filter(g => g.title.toLowerCase().includes(query) || g.game.toLowerCase().includes(query));
  const events = EVENTS.filter(e => e.title.toLowerCase().includes(query) || e.game.toLowerCase().includes(query));

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
      <form onSubmit={(e) => { e.preventDefault(); setParams({ q: term }); }} className="glass rounded-2xl p-2 flex items-center gap-2 mb-8 max-w-3xl">
        <SearchIcon className="w-5 h-5 text-slate-400 ml-3" />
        <input data-testid="search-page-input" value={term} onChange={e => setTerm(e.target.value)} className="flex-1 bg-transparent py-3 text-white focus:outline-none" placeholder="Rechercher…" aria-label="Rechercher dans Perform" />
        <button data-testid="search-page-submit" className="btn-primary text-white font-semibold px-4 py-3 rounded-xl text-sm">Rechercher</button>
      </form>
      <div data-testid="search-results-summary" className="mb-6 text-slate-400 break-words">Résultats pour <span className="text-white font-semibold">« {q} »</span></div>

      {games.length > 0 && <section className="mb-10">
        <h2 className="font-display font-bold text-white text-xl mb-4">Games</h2>
        <div className="flex flex-wrap gap-3">
          {games.map(g => <Link key={g.slug} data-testid={`search-game-${g.slug}`} to={`/games/${g.slug}`} className="glass px-4 py-2 rounded-full text-sm text-white hover:border-blue-500/50">{g.title}</Link>)}
        </div>
      </section>}

      {coaches.length > 0 && <section className="mb-10">
        <h2 className="font-display font-bold text-white text-xl mb-4">Coaches ({coaches.length})</h2>
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-4">
          {coaches.slice(0,8).map(c => (
            <Link key={c.username} data-testid={`search-coach-${c.username}`} to={`/coach/${c.username}`} className="glass rounded-2xl p-4 card-hover flex items-center gap-3">
              <img src={c.avatar} className="w-12 h-12 rounded-lg object-cover" alt="" />
              <div className="min-w-0">
                <div className="font-semibold text-white text-sm truncate">{c.name}</div>
                <div className="text-xs text-slate-400">{c.game}</div>
              </div>
            </Link>
          ))}
        </div>
      </section>}

      {guides.length > 0 && <section className="mb-10">
        <h2 className="font-display font-bold text-white text-xl mb-4">Guides ({guides.length})</h2>
        <div className="grid md:grid-cols-3 gap-4">
          {guides.slice(0,6).map(g => (
            <div key={g.id} className="glass rounded-2xl p-4 flex items-center gap-3">
              <img src={g.cover} className="w-14 h-14 rounded-lg object-cover" alt="" />
              <div className="min-w-0"><div className="font-semibold text-white text-sm truncate">{g.title}</div><div className="text-xs text-slate-400">€{g.price}</div></div>
            </div>
          ))}
        </div>
      </section>}

      {events.length > 0 && <section className="mb-10">
        <h2 className="font-display font-bold text-white text-xl mb-4">Events ({events.length})</h2>
        <div className="grid md:grid-cols-2 gap-4">
          {events.map(e => (
            <div key={e.id} className="glass rounded-2xl p-4 flex items-center gap-3">
              <img src={e.image} className="w-14 h-14 rounded-lg object-cover" alt="" />
              <div className="min-w-0"><div className="font-semibold text-white text-sm truncate">{e.title}</div><div className="text-xs text-slate-400">{e.date}</div></div>
            </div>
          ))}
        </div>
      </section>}

      {q && coaches.length === 0 && games.length === 0 && guides.length === 0 && events.length === 0 && (
        <div data-testid="search-empty-state" className="text-center py-16 text-slate-400">Aucun résultat. Essayez un autre mot-clé.</div>
      )}
    </div>
  );
}
